// extracted by mini-css-extract-plugin
export default {"wrapper":"SelfPickupFilters_wrapper__sd_IL"};